import { Link } from 'react-router-dom';

interface ShopHeaderProps {
  activeFilters: number;
}

export default function ShopHeader({ activeFilters }: ShopHeaderProps) {
  return (
    <section className="bg-primary-500 py-10 md:py-14">
      <div className="max-w-none mx-auto px-4 md:px-6">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-xs md:text-sm font-label mb-3">
          <Link
            to="/"
            className="text-background-50/60 hover:text-background-50 transition-colors"
          >
            Home
          </Link>
          <span className="text-background-50/30">
            <i className="ri-arrow-right-s-line text-xs"></i>
          </span>
          <span className="text-background-50/90">Shop All</span>
        </nav>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50">
          Shop All
        </h1>
        <p className="text-sm md:text-base text-background-50/70 mt-2 font-label max-w-xl">
          18 pieces designed for real life — sweat-proof, water-resistant, and made to stay gold.
        </p>

        {activeFilters > 0 && (
          <div className="mt-4">
            <span className="text-xs font-label text-accent-500 bg-accent-500/15 px-3 py-1 rounded-full">
              {activeFilters} filter{activeFilters > 1 ? 's' : ''} active
            </span>
          </div>
        )}
      </div>
    </section>
  );
}